export default {
  particleChartlet: {
    title: 'Particle Thumbnail',
  },
  particlePlay: {
    title: 'Playback Settings',
    cycleIndex: 'Loop Times',
    startBtn: 'Play particles effects',
    stopBtn: 'Pause particle effects',
    sequence: 'Times',
    LoopPlayback: 'Loop Playback',
    playOnAwake: 'Autoplay',
  },
  particleSetting: {
    particleParameter: 'Particle parameters',
    particleDynamicParameter: 'Physics Parameters',
    overLifespan: '粒子渐变参数',
    changingCurve: 'Curve',
    zoneType: {
      title: 'Launch Area',
      detail:
        'Four types are supported: Zone. POINT , Zone. LINE , Zone. CIRCLE , Zone. RECTANGLE',
    },
    zoneLength: {
      title: 'Area Line',
      detail: 'Length of the emission area',
    },
    zoneRotation: {
      title: 'Area Rotation',
      detail: 'Rotation of the emission area',
    },
    zoneRadius: {
      title: 'Zone Radius',
      detail: 'Radius of the emission area',
    },
    zoneWidth: {
      title: 'Zone Width',
      detail: 'Width of the emission area',
    },
    zoneHeight: {
      title: 'Zone Height',
      detail: 'Height of the emission area',
    },
    edgeEmission: {
      title: 'Edge Emission',
      detail: 'Edge Emission',
    },
    emissionSpace: {
      title: 'Emission Space',
      detail: 'Local or World coordinate system',
    },
    quantity: {
      title: 'Number of particles',
      detail: 'Number of particles per emission',
    },
    frequency: {
      title: 'Frequency',
      detail: 'Frequency of emission',
    },
    startScaleMin: {
      title: 'Minimum particle size',
      detail: 'Minimum particle size',
    },
    startScaleMax: {
      title: 'Maximum particle size',
      detail: 'Maximum particle size',
    },
    startAlphaMax: {
      title: 'Maximum transparency',
      detail: 'Maximum transparency',
    },
    startAlphaMin: {
      title: 'Minimum transparency',
      detail: 'Minimum transparency',
    },
    startRotationMin: {
      title: 'Minimum rotation angle',
      detail: 'Minimum rotation angle',
    },
    startRotationMax: {
      title: 'Maximum rotation angle',
      detail: 'Maximum rotation angle',
    },
    startVelocityMin: {
      title: 'Minimum speed',
      detail: 'Minimum speed',
    },
    startVelocityMax: {
      title: 'Maximum speed',
      detail: 'Maximum speed',
    },
    lifespanMin: {
      title: 'Minimum life cycle',
      detail: 'Minimum life cycle',
    },
    lifespanMax: {
      title: 'Maximum life cycle',
      detail: 'Maximum life cycle',
    },
    gravityX: {
      title: 'Additional X Velocity',
      detail: 'Gravity of X',
    },
    gravityY: {
      title: 'Additional Y Velocity',
      detail: 'Gravity of Y',
    },
    maxParticles: {
      title: '最大粒子数',
      detail:
        'Stop emitting particles when the number of particles exceeds this value',
    },
    delay: {
      title: '发射延迟',
      detail: 'Delay of emitted particles',
    },
    blendMode: {
      title: '混合模式',
      detail: 'Blend Mode',
    },
    startColor: {
      title: '出生颜色',
      detail: 'Color when particles are generated',
    },
    startColorVariation: {
      title: '出生颜色浮动',
      detail: 'Color float when particles are generated',
    },
    endColor: {
      title: 'End Color',
      detail: 'Color at the end of the particle’s life.',
    },
    endColorVariation: {
      title: 'End Color Float',
      detail: 'Color float at the end of the particle’s life.',
    },
    angleMin: {
      title: '最小发射角度',
      detail: 'Min emission angle',
    },
    angleMax: {
      title: '最大发射角度',
      detail: 'Max emission angle',
    },
    angularVelocityMin: {
      title: '最小角速度',
      detail: 'Min angular velocity',
    },
    angularVelocityMax: {
      title: '最大角速度',
      detail: 'Max angular velocity',
    },
    colorCurve: {
      title: 'Color over lifespan',
      detail: 'Color over lifespan',
    },
    alphaCurve: {
      title: 'Alpha over lifespan',
      detail: 'Alpha over lifespan',
    },
    scaleCurve: {
      title: 'Scale over lifespan',
      detail: 'Scale over lifespan',
    },
    velocityCurve: {
      title: 'Velocity over lifespan',
      detail: 'Velocity over lifespan',
    },
    angularVelocityCurve: {
      title: 'Angular Velocity over lifespan',
      detail: 'Angular Velocity over lifespan',
    },
  },
}
